import React from 'react';
import CreateDeclarationFormPage from './components/CreateDeclarationFormPage';
import CustomLayout from '@/common/Layout';
import { /* getLoggedInUser, */ TabTitle } from '../../utilities/helpers';
import { useLocation } from 'react-router-dom';

const CreateDeclarationForm = () => {
  TabTitle('Welcome to the Gift Register - Declaration Form');
  // const user_role1 = getLoggedInUser();
  // const user_role = user_role1?.user;
  const location = useLocation();
  const declarationRecord = location?.state?.declarationRecord || null;
  console.log('declarationRecord', declarationRecord);
  return (
    <>
      <CustomLayout>
        <div style={{ marginTop: '50px' }}>
          <CreateDeclarationFormPage
            declarationRecord={declarationRecord} /* user_role={user_role} */
          />
        </div>
      </CustomLayout>
    </>
  );
};

export default CreateDeclarationForm;
